import { render, staticRenderFns } from "./suggestedResourceTable.vue?vue&type=template&id=269d4144&scoped=true"
import script from "./suggestedResourceTable.vue?vue&type=script&lang=ts"
export * from "./suggestedResourceTable.vue?vue&type=script&lang=ts"
import style0 from "./suggestedResourceTable.vue?vue&type=style&index=0&id=269d4144&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269d4144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('269d4144')) {
      api.createRecord('269d4144', component.options)
    } else {
      api.reload('269d4144', component.options)
    }
    module.hot.accept("./suggestedResourceTable.vue?vue&type=template&id=269d4144&scoped=true", function () {
      api.rerender('269d4144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/suggestedResourceTable.vue"
export default component.exports